export enum PricingLevel {
	B2c = "B2c",
	Level0 = "Level0",
	Level5 = "Level5",
	Level10 = "Level10",
	Level15 = "Level15",
	Level20 = "Level20",
	Level25 = "Level25",
	Level30 = "Level30",
}

export const PricingLevelB2b = {
	[PricingLevel.Level0]: PricingLevel.Level0,
	[PricingLevel.Level5]: PricingLevel.Level5,
	[PricingLevel.Level10]: PricingLevel.Level10,
	[PricingLevel.Level15]: PricingLevel.Level15,
	[PricingLevel.Level20]: PricingLevel.Level20,
	[PricingLevel.Level25]: PricingLevel.Level25,
	[PricingLevel.Level30]: PricingLevel.Level30,
} satisfies Record<PricingLevelB2b, PricingLevel>;

export type PricingLevelB2b = Exclude<PricingLevel, PricingLevel.B2c>;

export const PricingLevelEditableDiscount = {
	[PricingLevel.Level5]: PricingLevel.Level5,
	[PricingLevel.Level10]: PricingLevel.Level10,
	[PricingLevel.Level15]: PricingLevel.Level15,
	[PricingLevel.Level20]: PricingLevel.Level20,
	[PricingLevel.Level25]: PricingLevel.Level25,
	[PricingLevel.Level30]: PricingLevel.Level30,
} satisfies Record<PricingLevelEditableDiscount, PricingLevel>;

export type PricingLevelEditableDiscount = Exclude<PricingLevel, PricingLevel.Level0 | PricingLevel.B2c>;

export const PricingLevelEditable = {
	[PricingLevel.B2c]: PricingLevel.B2c,
	[PricingLevel.Level5]: PricingLevel.Level5,
	[PricingLevel.Level10]: PricingLevel.Level10,
	[PricingLevel.Level15]: PricingLevel.Level15,
	[PricingLevel.Level20]: PricingLevel.Level20,
	[PricingLevel.Level25]: PricingLevel.Level25,
	[PricingLevel.Level30]: PricingLevel.Level30,
} satisfies Record<PricingLevelEditable, PricingLevel>;

export type PricingLevelEditable = Exclude<PricingLevel, PricingLevel.Level0>;
